/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import Card from '@material-ui/core/Card';
import withStyles from '@material-ui/core/styles/withStyles';
import Remove from '@material-ui/icons/Remove';
import Add from '@material-ui/icons/Add';
import { useUIDSeed } from 'react-uid';
import {
    bool, string, array, object, shape,
} from 'prop-types';
import GraphqlWineDisclaimer from '../GraphqlWineDisclaimer/WineDisclaimerContainer';
import { selectedSkuType } from '../common/types';

const styles = (theme) => ({
    listContent: {
        fontSize: '16px',
        color: theme?.palette?.colorPrimary,
    },
    longDescMarkDown: {
        margin: '-13px 16px 0px -20px',
    },
    rootMobile: {
        [theme.breakpoints.up(1025)]: {
            display: 'none',
        },
    },
    card: {
        marginBottom: '10px',
        background: theme.palette.white,
        boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)',
        borderRadius: '4px',
        padding: '16px 16px 0',
        position: 'relative',
    },
    heading: {
        fontSize: '0.9em',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        fontamily: theme.fontFamily,
        lineHeight: '1.5',
    },
    allAvailableContent: {
        height: '100%',
        display: 'inline-block',
        fontSize: '1em',
    },
    trimmedContent: {
        height: '110px',
    },
    toggleDescription: {
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        position: 'absolute',
        bottom: 0,
        right: '16px',
        backgroundImage: 'linear-gradient(to bottom,rgba(255,255,255,0) 0,rgba(255,255,255,1) 30%)',
    },
    readMore: {
        fontSize: '1.4em',
        margin: '0 3px -4px 0',
    },
    readLess: {
        fontSize: '1.4em',
        margin: '0 3px -4px 0',
    },
    buttonWrapperStatic: {
        position: 'static',
    },
    mobileDivider: {
        borderTop: `1px solid ${theme.palette.grey8 || '#cccccc'}`,
    },
    toggleReadButton: {
        color: theme.palette.colorPrimary,
        fontSize: '0.8em',
        fontWeight: '700',
        border: 'none',
        cursor: 'pointer',
        background: theme.palette.white,
        lineHeight: '1.5',
        padding: '6px 8px',
        margin: '0 4px 5px',
        borderRadius: '4px',
        '&:focus': {
            outline: 'none',
        },
        '&:hover': {
            textDecoration: 'none',
        },
    },
});

const GraphqlFoodDetailsUIMobile = ({
    classes, shortDescription, productContentsDescription, longDescription, selectedSku, productContents, clubDescription, isPassportBundleProduct,
}) => {
    const seed = useUIDSeed();
    const [showLongDescription, setShowLongDescription] = useState(false);
    const [showBundleLongDescription, setShowBundleLongDescription] = useState(false);
    const [showLongContents, setShowLongContents] = useState(false);

    return   (
        <div className={classes.rootMobile}>
            <Card className={classes.card} variant="outlined">
                <div className={classes.heading}>
                    Description
                </div>
                <div className={showLongDescription ? classes.allAvailableContent : classes.trimmedContent}>
                    <ReactMarkdown
                        source={shortDescription}
                        escapeHtml={false}
                    />
                    {productContentsDescription && <div><ReactMarkdown source={longDescription} escapeHtml={false} /></div>}
                    {selectedSku?.ageVerifyFlag === 'true'
                    && (
                        <div className={classes.mobileDivider}>
                            <div className={classes.divider} />
                            <GraphqlWineDisclaimer />
                        </div>
                    )}
                </div>
                {shortDescription.length >= 208
                    ? (
                        <div className={`${classes.toggleDescription} ${showLongDescription ? classes.buttonWrapperStatic : ''}`}>
                            <button
                                className={classes.toggleReadButton}
                                type="button"
                                onClick={() => setShowLongDescription(!showLongDescription)}
                            >
                                {showLongDescription
                                    ? (<><Remove className={classes.readMore} />Read Less</>)
                                    : (<><Add className={classes.readLess} />Read More</>)}
                            </button>
                        </div>
                    ) : null}
            </Card>

            {productContentsDescription?.length > 0 || longDescription?.length > 0
                ? (
                    <Card className={classes.card} variant="outlined">
                        <div className={classes.heading}>
                            Contents
                        </div>
                        <div className={showLongContents ? classes.allAvailableContent : classes.trimmedContent}>
                            {productContents && clubDescription ? (
                                <ul>
                                    {
                                        productContents.map((contents) => (
                                            <li key={seed(contents)} className={classes.listContent}>{clubDescription ? <ReactMarkdown source={contents} escapeHtml={false} /> : contents}</li>
                                        ))
                                    }
                                </ul>
                            ) : <ReactMarkdown source={productContentsDescription || longDescription} escapeHtml={false} className={classes.longDescMarkDown} />}
                        </div>
                        {productContentsDescription?.length >= 150 || longDescription?.length >= 150
                            ? (
                                <div className={`${classes.toggleDescription} ${showLongContents ? classes.buttonWrapperStatic : ''}`}>
                                    <button
                                        className={classes.toggleReadButton}
                                        type="button"
                                        onClick={() => setShowLongContents(!showLongContents)}
                                    >
                                        {showLongContents
                                            ? (<><Remove className={classes.readMore} />Read Less</>)
                                            : (<><Add className={classes.readLess} />Read More</>)}
                                    </button>
                                </div>
                            ) : null}
                    </Card>
                )
                : null}
            {isPassportBundleProduct?.enable && (
                <Card className={classes.card} variant="outlined">
                    <div className={classes.heading}>
                        Celebrations Passport Details: {isPassportBundleProduct?.details?.item_sku}
                    </div>
                    <div className={showBundleLongDescription ? classes.allAvailableContent : classes.trimmedContent}>
                        <ReactMarkdown
                            source={isPassportBundleProduct?.details?.long_description}
                            escapeHtml={false}
                        />
                    </div>
                    {isPassportBundleProduct?.details?.long_description.length >= 208
                        ? (
                            <div className={`${classes.toggleDescription} ${showBundleLongDescription ? classes.buttonWrapperStatic : ''}`}>
                                <button
                                    className={classes.toggleReadButton}
                                    type="button"
                                    onClick={() => setShowBundleLongDescription(!showBundleLongDescription)}
                                >
                                    {showBundleLongDescription
                                        ? (<><Remove className={classes.readMore} />Read Less</>)
                                        : (<><Add className={classes.readLess} />Read More</>)}
                                </button>
                            </div>
                        ) : null}
                </Card>
            )}
        </div>
    );
};

GraphqlFoodDetailsUIMobile.propTypes = {
    classes: object.isRequired,
    clubDescription: bool,
    shortDescription: string.isRequired,
    productContents: array.isRequired,
    longDescription: string.isRequired,
    selectedSku: selectedSkuType,
    productContentsDescription: string,
    isPassportBundleProduct: shape({
        enable: bool,
        details: shape({
            long_description: string,
        }),
    }),
};

GraphqlFoodDetailsUIMobile.defaultProps = {
    clubDescription: false,
    selectedSku: {},
    productContentsDescription: '',
    isPassportBundleProduct: {},
};

export default withStyles(styles)(GraphqlFoodDetailsUIMobile);
